import { Box, Button, ButtonGroup, IconButton, TextField, Typography, CircularProgress } from '@mui/material'
import React from 'react'
import './assetDashboard.css'
import DarkUnica from 'highcharts/themes/dark-unica'
import * as HighCharts from 'highcharts'
import EditIcon from '../../../assets/Edit.svg'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import ApexCharts from 'react-apexcharts'
import { type GetDefaultWidgetDataState } from '../../device-dashboard/redux/getSaveDefaultViewServiceSlice'
import { type ConnectedProps, connect, useSelector } from 'react-redux'
import { type RootState } from '../../../store'
import { getAlertTrendKPIDataDashboardService, getAlertTrendRegisterDataDashboardService } from '../redux/actionCreator'
import AuthError from '../../../components/ErrorComponents/AuthError'
import dayjs from 'dayjs'
import moment from 'moment-timezone'
import { updateSaveDefaultObject } from '../../../utils/updateSaveDefaultObject'
import { DEFAULT_DATA_WINDOW_HOURS } from '../../../utils/DashboardContants'

const AssetAlertTrend = (props: AllProps): JSX.Element => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const [range, setRange] = React.useState({ selectedTime: 'hourly', timezone: userTimezone, status: props.customeSelection ? 'Custom range' : 'Go live' })
  const [isEditing, setIsEditing] = React.useState(false)
  const [text, setText] = React.useState('Alert Trend')
  const [combinedData, setCombinedData] = React.useState<any>([])
  const AlertRegisterData: any = useSelector((state: RootState) => state.alertTrendRegisterAssetDashboard)
  const AlertKPIData: any = useSelector((state: RootState) => state.alertTrendKPIAssetDashboard)
  const saveDefaultViewObject = useSelector((state: RootState) => state.saveDefaultViewObject.saveDefaultViewObject)
  const [selectedGraphData, setSelectedGraphData] = React.useState<Array<{ deviceId: string, cimCodeIds: string[] }>>([])
  const dashboardHours = DEFAULT_DATA_WINDOW_HOURS

  const defaultParam = JSON.stringify({
    assetId: props.parentAssetId,
    devices: []
  })

  const defaultParamKPI = JSON.stringify({
    assetId: props.parentAssetId,
    devices: [],
    assets: []
  })

  const getUtcDateRange = (): { today: string, defaultDataWindowUTC: string } => {
    const utcDate = dayjs()
    const today = utcDate.utc().format('YYYY-MM-DD HH:mm:ss')
    const defaultDataWindowUTC = utcDate.utc().subtract(dashboardHours, 'hour').format('YYYY-MM-DD HH:mm:ss')
    return { today, defaultDataWindowUTC }
  }

  React.useEffect(() => {
    setRange({ selectedTime: 'hourly', timezone: userTimezone, status: props.customeSelection ? 'Custom range' : 'Go live' })
  }, [props.Golive])

  React.useEffect(() => {
    if (props.startDate === '' || props.endDate === '') return
    const differenceInHours = (new Date(props.endDate).getTime() - new Date(props.startDate).getTime()) / (1000 * 60 * 60)
    let selectedTime = range?.selectedTime
    if (differenceInHours >= 25) {
      selectedTime = 'daily'
      setRange(prevRange => ({ ...prevRange, selectedTime: 'daily' }))
    }
    // Fetching Alert Trend
    props.getAlertTrendKPIDataDashboardService(props.startDate, props.endDate, 'assetAlertTrend', defaultParamKPI, `${selectedTime},${range.timezone},${range.status}`, true)
    props.getAlertTrendRegisterDataDashboardService(props.startDate, props.endDate, 'assetAlertTrend', defaultParam, `${selectedTime},${range.timezone},${range.status}`, true)
  }, [props.startDate, props.endDate, props.tabSwitch]) // tabSwitch When switch tab since DOM issues

  React.useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (!AlertRegisterData.isLoading && !AlertKPIData.isLoading) {
      const AlertData = AlertRegisterData?.AlertTrendRegisterDataAssetDashboard ?? []
      const AlertDeviceKPI = AlertKPIData?.AlertTrendKPIDataAssetDashboard?.deviceReadings ?? []
      const AlertAssetKPI = AlertKPIData?.AlertTrendKPIDataAssetDashboard?.assetReadings ?? []

      const combinedData: any = []

      AlertData.forEach((device: any) => {
        device.paraMeterReadings.forEach((reading: any) => {
          combinedData.push({
            paraMeterId: reading.paraMeterId,
            paraMeterName: reading.paraMeterName,
            deviceName: device.deviceName,
            unit: reading.unit,
            paraMeterReading: reading.paraMeterReading
          })
        })
      })

      AlertDeviceKPI.forEach((device: any) => {
        device.paraMeterReadings.forEach((reading: any) => {
          combinedData.push({
            paraMeterId: reading.paraMeterId,
            paraMeterName: reading.paraMeterName,
            deviceName: device.deviceName,
            unit: reading.unit,
            paraMeterReading: reading.paraMeterReading
          })
        })
      })

      AlertAssetKPI.forEach((device: any) => {
        device.paraMeterReadings.forEach((reading: any) => {
          combinedData.push({
            paraMeterId: reading.paraMeterId,
            paraMeterName: reading.paraMeterName,
            deviceName: device.deviceName,
            unit: reading.unit,
            paraMeterReading: reading.paraMeterReading
          })
        })
      })

      setCombinedData(combinedData)
    }
  }, [AlertRegisterData, AlertKPIData])

  const handleEditClick = (): void => {
    setIsEditing(true)
  }

  const selectedData = React.useRef<any>(null)

  React.useEffect(() => {
    if (saveDefaultViewObject !== null && saveDefaultViewObject !== undefined) {
      selectedData.current = findWidget(saveDefaultViewObject, 'assetAlertTrend')
    }
  }, [saveDefaultViewObject])

  const findWidget = (obj: any, widgetID: string): any => {
    const { assetDashBoardDefaultView } = obj
    const match = assetDashBoardDefaultView.find((widget: any) => widget?.widgetId === widgetID)
    return match !== undefined ? match : null
  }

  const handleTextChange = (event: any): void => {
    setText(event.target.value)
    const newValue = event.target.value
    if (selectedData.current !== null) {
      selectedData.current = { ...selectedData.current, displayname: newValue }
    }
    updateTitleOnSaveDefaultObj(newValue, 'assetAlertTrend')
  }

  const updateTitleOnSaveDefaultObj = (title: string, widgetID: string): void => {
    const selectedDefaultData = {
      widgetId: widgetID,
      displayname: title,
      devices: selectedGraphData,
      assets: []
    }
    updateSaveDefaultObject(saveDefaultViewObject, selectedData.current !== null ? selectedData.current : selectedDefaultData, widgetID)
  }

  const setDisplayname = (data: any, widgetId: string): void => {
    for (const widget of data.assetDashBoardDefaultView) {
      if (widget.widgetId === widgetId) {
        setText(widget.displayname)
        break
      }
    }
  }

  React.useEffect(() => {
    if (typeof props.saveDefaultWidgetData.DefaultWidgetData !== 'undefined') {
      setDisplayname(props.saveDefaultWidgetData.DefaultWidgetData, 'assetAlertTrend')
      const gdata = generateSelectedGraphData(props.saveDefaultWidgetData.DefaultWidgetData, 'assetAlertTrend')
      setSelectedGraphData(gdata)
    }
  }, [props.saveDefaultWidgetData])

  const generateSelectedGraphData = (data: any, widgetId: string): Array<{ deviceId: string, cimCodeIds: string[] }> => {
    const selectedGraph = data.assetDashBoardDefaultView.find((widget: any) => widget.widgetId === widgetId)
    if (selectedGraph !== null && selectedGraph !== undefined) {
      return selectedGraph.devices.map((device: any) => ({
        deviceId: device.deviceId,
        cimCodeIds: device.cimCodeIds
      }))
    }
    return []
  }

  const handleBlur = (): void => {
    setIsEditing(false)
  }

  const disableHourly = (): boolean => {
    const differenceInHours: number = (new Date(props.endDate).getTime() - new Date(props.startDate).getTime()) / (1000 * 60 * 60)
    return differenceInHours >= 25
  }

  const handleRangeChange = (interval: string): void => {
    const { today, defaultDataWindowUTC } = getUtcDateRange()
    const endDateLocal = dayjs()
    let startDate = ''
    let endDate = endDateLocal.format('YYYY-MM-DD HH:mm:ss')

    const getStartDate = (unit: dayjs.OpUnitType, subtractValue = 0, startOfUnit = true): string => {
      const date = (typeof subtractValue === 'number' && !isNaN(subtractValue) && subtractValue !== 0) ? endDateLocal.subtract(subtractValue, unit as dayjs.ManipulateType) : endDateLocal
      return startOfUnit ? date.startOf(unit).utc().format('YYYY-MM-DD HH:mm:ss') : date.endOf(unit).utc().format('YYYY-MM-DD HH:mm:ss')
    }

    switch (interval) {
      case 'hourly':
        startDate = defaultDataWindowUTC
        endDate = today
        break
      case 'daily':
        startDate = getStartDate('day')
        endDate = endDateLocal.utc().format('YYYY-MM-DD HH:mm:ss')
        break

      case 'weekly':
        startDate = getStartDate('week')
        endDate = endDateLocal.utc().format('YYYY-MM-DD HH:mm:ss')
        break

      case 'monthly':
        startDate = getStartDate('month')
        endDate = endDateLocal.utc().format('YYYY-MM-DD HH:mm:ss')
        break
    }

    setRange(prevRange => ({ ...prevRange, selectedTime: interval }))

    if (props.endDate === '') {
      props.getAlertTrendRegisterDataDashboardService(startDate, endDate, 'assetAlertTrend', defaultParam, `${interval},${range.timezone},${props.customeSelection ? 'Custom range' : 'Go live'}`, true)
      props.getAlertTrendKPIDataDashboardService(startDate, endDate, 'assetAlertTrend', defaultParamKPI, `${interval},${range.timezone},${props.customeSelection ? 'Custom range' : 'Go live'}`, true)
    } else {
      props.getAlertTrendRegisterDataDashboardService(props.startDate, props.endDate, 'assetAlertTrend', defaultParam, `${interval},${range.timezone},${props.customeSelection ? 'Custom range' : 'Go live'}`, true)
      props.getAlertTrendKPIDataDashboardService(props.startDate, props.endDate, 'assetAlertTrend', defaultParamKPI, `${interval},${range.timezone},${props.customeSelection ? 'Custom range' : 'Go live'}`, true)
    }
  }

  const [series, setSeries] = React.useState<any[]>([])
  const [chartOptions, setChartOptions] = React.useState({
    chart: {
      type: 'bar' as const,
      background: '#252525',
      height: 350,
      stacked: true,
      toolbar: {
        show: false
      },
      zoom: {
        enabled: false
      }
    },
    responsive: [{
      breakpoint: 480,
      options: {
        legend: {
          position: 'bottom' as const,
          offsetX: -10,
          offsetY: 0
        }
      }
    }],
    dataLabels: {
      enabled: false
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        dataLabels: {
          total: {
            enabled: false,
            style: {
              fontSize: '13px',
              fontWeight: 900
            }
          }
        }
      }
    },
    tooltip: {
      enabled: true,
      theme: 'dark',
      x: {
        show: false // Disable showing x-axis value or time
      },
      formatter: function (value: number) {
        return `${Math.round(value)}` // Only show the parameter value
      }
    },
    xaxis: {
      categories: [] as string[],
      title: {
        text: '',
        style: {
          color: '#D0D0D0',
          fontFamily: '"Honeywell Sans Web", Arial, Helvetica, sans-serif',
          fontSize: '11px'
        }
      },
      labels: {
        show: true,
        rotate: -90,
        rotateAlways: true,
        style: {
          colors: '#D0D0D0',
          fontFamily: '"Honeywell Sans Web", Arial, Helvetica, sans-serif',
          fontSize: '15px'
        }
      },
      axisBorder: {
        show: true,
        color: '#D0D0D0',
        height: 1,
        offsetX: 0,
        offsetY: 0
      },
      axisTicks: {
        show: false,
        borderType: 'solid',
        color: '#D0D0D0',
        height: 60,
        offsetX: 20,
        offsetY: 20
      },
      crosshairs: {
        show: true,
        width: 1,
        position: 'back',
        opacity: 0.9,
        stroke: {
          color: '#D0D0D0',
          width: 1,
          dashArray: 0
        }
      }
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      title: {
        text: 'Count',
        style: {
          color: '#D0D0D0',
          fontFamily: '"Honeywell Sans Web", Arial, Helvetica, sans-serif',
          fontSize: '14px'
        }
      },
      axisTicks: {
        show: false
      },
      labels: {
        show: true,
        style: {
          colors: '#D0D0D0',
          fontFamily: '"Honeywell Sans Web", Arial, Helvetica, sans-serif',
          fontSize: '15px'
        },
        formatter: function (value: number) {
          return Math.round(value).toString()
        }
      },
      tickAmount: 1
    },
    noData: {
      text: 'No Data Available',
      offsetX: 20,
      offsetY: -10,
      style: {
        color: '#F2F2F2',
        fontSize: '14px'
      }
    },
    annotations: {
      yaxis: []
    },
    legend: {
      show: true,
      showForSingleSeries: true,
      fontSize: '14px',
      fontFamily: '"Honeywell Sans Web", Arial, Helvetica, sans-serif',
      position: 'bottom' as const,
      itemMargin: {
        horizontal: 5,
        vertical: 10
      },
      labels: {
        colors: '#D0D0D0',
        fontFamily: '"Honeywell Sans Web", Arial, Helvetica, sans-serif',
        fontSize: '14px',
        useSeriesColors: false
      },
      margin: {
        top: 15
      },
      onItemClick: {
        toggleDataSeries: true
      },
      onItemHover: {
        highlightDataSeries: true
      }
    },
    fill: {
      opacity: 1
    }
  })

  React.useEffect(() => {
    const formatReadingTime = (readingTime: any): string => {
      const date = moment.utc(readingTime).format('YYYY-MM-DD hh:mm:ss A')
      const dateObj = new Date(date)
      return range.selectedTime === 'hourly' ? dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : dateObj.toLocaleDateString()
    }

    const allZero = combinedData.every((data: { paraMeterReading: Array<{ count: number }> }) =>
      data.paraMeterReading.every((reading: { count: number }) => reading.count === 0)
    )

    const uniqueTimes = (Array.isArray(combinedData) && combinedData.length > 0 && Array.isArray(combinedData[0].paraMeterReading))
      ? combinedData[0].paraMeterReading.map((reading: { readingTime: string, count: any }) => formatReadingTime(reading.readingTime))
      : []

    const series: any = (Array.isArray(combinedData) ? combinedData : []).map(alert => {
      const data = alert.paraMeterReading.map((reading: { readingTime: string, count: any }) => ({
        x: moment.utc(reading.readingTime).format('YYYY-MM-DD hh:mm:ss A'),
        y: reading.count,
        originalY: reading.count // Store original value
      }))
      return {
        name: alert.paraMeterName,
        data,
        visible: true // Ensure visibility is defined initially
      }
    })

    setSeries(series)

    setChartOptions(prevOptions => ({
      ...prevOptions,
      xaxis: {
        ...prevOptions.xaxis,
        categories: uniqueTimes
      },
      yaxis: {
        ...prevOptions.yaxis,
        min: allZero === true ? 0 : undefined,
        max: allZero === true ? 5 : undefined
      },
      annotations: {
        yaxis: allZero === true
          ? [
              {
                y: 0,
                borderColor: '#252525',
                label: {
                  borderColor: '#252525',
                  style: {
                    color: '#fff',
                    background: '#252525',
                    fontSize: '16px',
                    textAlign: 'center'
                  },
                  text: 'Selected Register or KPI has No Data',
                  offsetX: -140,
                  offsetY: -30
                }
              }
            ] as any
          : []
      }
    }))
  }, [combinedData])

  DarkUnica(HighCharts)
  return (
    <>
    <Box
      sx={{
        backgroundColor: '#252525',
        padding: '10px',
        borderRadius: '8px',
        flex: 1
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
          {isEditing
            ? (
            <TextField
              value={text}
              onChange={handleTextChange}
              onBlur={handleBlur}
              autoFocus
              variant="outlined"
              size="small"
              sx={{ input: { color: '#f0f0f0' } }}
              autoComplete='false'
            />
              )
            : (
            <Typography className='title-box' sx={{ color: '#f0f0f0' }}>{text}</Typography>
              )}
          <IconButton onClick={handleEditClick} size="small" sx={{ color: '#f0f0f0' }}>
           <img src={EditIcon} />
          </IconButton>
        </div>
        <div>
        <IconButton onClick={props.setIsOpenModalAlertTrend}>
        <MoreVertIcon />
      </IconButton>
        </div>
      </div>
      <div>
      <ButtonGroup className='range-handle' color="primary" aria-label="outlined primary button group" sx={{ mb: 2 }}>
      <Button
          data-testid='hourly'
          variant={range.selectedTime === 'hourly' ? 'contained' : 'outlined'}
          onClick={() => { handleRangeChange('hourly') }}
          disabled={disableHourly()}
        >
          H
        </Button>
        <Button
          data-testid='daily'
          variant={range.selectedTime === 'daily' ? 'contained' : 'outlined'}
          onClick={() => { handleRangeChange('daily') }}
        >
          D
        </Button>
        <Button
          data-testid='weekly'
          variant={range.selectedTime === 'weekly' ? 'contained' : 'outlined'}
          onClick={() => { handleRangeChange('weekly') }}
        >
          W
        </Button>
        <Button
          data-testid='monthly'
          variant={range.selectedTime === 'monthly' ? 'contained' : 'outlined'}
          onClick={() => { handleRangeChange('monthly') }}
        >
          M
        </Button>
      </ButtonGroup>
      <div id='chart-container'>
        {
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          (AlertRegisterData.httpStatus === 404 && AlertKPIData.httpStatus === 404) || (AlertRegisterData.httpStatus === 500 || AlertKPIData.httpStatus === 500) || (AlertRegisterData.httpStatus === 204 || AlertKPIData.httpStatus === 204)
            ? <div style={{ display: 'flex', height: '350px', justifyContent: 'center', alignItems: 'center', color: '#f0f0f0' }}>  <AuthError
            className='alertTrendError'
            errorMessage='NoDataPresentAlertTrend'
          /></div>
            : (AlertRegisterData.isLoading === true || AlertKPIData.isLoading === true)
                ? <div style={{ display: 'flex', height: '350px', justifyContent: 'center', alignItems: 'center' }} ><CircularProgress /></div>
                : <ApexCharts
              options={chartOptions}
              series={series}
              type={chartOptions.chart.type}
              height={350}
            />
        }
      </div>
      {props.dialogParameterSelection(props.isModalAlertTrend, 'assetAlertTrend')}
      </div>
    </Box>
   </>
  )
}

interface DispatchToProps {
  getAlertTrendKPIDataDashboardService: (startDate: string, endDate: string, graphName: string, requestParameter: string, intervalGroup: string, isdefault: boolean) => void
  getAlertTrendRegisterDataDashboardService: (startDate: string, endDate: string, graphName: string, requestParameter: string, intervalGroup: string, isdefault: boolean) => void
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  getAlertTrendKPIDataDashboardService: (startDate: string, endDate: string, graphName: string, requestParameter: string, intervalGroup: string, isdefault: boolean) => dispatch(getAlertTrendKPIDataDashboardService(startDate, endDate, graphName, requestParameter, intervalGroup, isdefault)),
  getAlertTrendRegisterDataDashboardService: (startDate: string, endDate: string, graphName: string, requestParameter: string, intervalGroup: string, isdefault: boolean) => dispatch(getAlertTrendRegisterDataDashboardService(startDate, endDate, graphName, requestParameter, intervalGroup, isdefault))
})

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface StateToProps {
  saveDefaultWidgetData: GetDefaultWidgetDataState
}

const mapStateToProps = (state: RootState): StateToProps => ({
  saveDefaultWidgetData: state.saveDefaultWidgetData
})

const connector = connect(mapStateToProps, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

interface InputProps {
  parentAssetId: string
  startDate: string
  endDate: string
  customeSelection: boolean
  isModalAlertTrend: boolean
  setIsOpenModalAlertTrend: any
  dialogParameterSelection: any
  Golive: boolean
  tabSwitch?: any
}

type AllProps = PropsFromRedux & InputProps

export const MemoAssetAlertTrend = React.memo(connector(AssetAlertTrend))
